<div *ngFor="let alert of alerts" class="{{cssClass(alert)}}" style="margin-top: 90px;">
    <a class="close" style="color: #ffffff;" (click)="removeAlert(alert)">&times;</a>
    <span [innerHTML]="alert.message"></span>
</div>